import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "aceCommaNewline"
})
export class AceCommaNewlinePipe implements PipeTransform {
  transform(str: string) {
    return str.replace(/,/g, "\n");
  }
}
